import React, { Component } from 'react';


class Footer extends Component {
  render() {
    return (

      <footer>
          <h3>2020 All rights reserved</h3>
          {/*<p>Support <br/> DesignLabs@supportme.com</p>*/}
          {/*<ul>*/}
          {/*  <li><a href="#"><i className="fab fa-facebook-f"></i></a></li>*/}
          {/*  <li><a href="#"><i className="fab fa-twitter"></i></a></li>*/}
          {/*  <li><a href="#"><i className="fab fa-instagram"></i></a></li>*/}
          {/*</ul>*/}

          {/*<span className="spanEndFooter">2020 All rights reserved</span>*/}
      </footer>

    );
  }
}

export default Footer;
